import {PeachPayCustomer} from '../../reducers/peachPayCustomerReducer';

/**
 * Returns an object containing address details for Amazon Pay
 * @returns addressObj Object containing address details
 */
function amazonCustomerAddress() {
	const {
		firstName,
		lastName,
		address1,
		address2,
		city,
		state,
		postal,
		country,
		phone,
	} = PeachPayCustomer.shipping;
	const additionalData = address2().length === 0 ? {} : {addressLine1: address2()};
	return {
		name: firstName() + ' ' + lastName(),
		addressLine1: address1(),
		city: city(),
		stateOrRegion: state(),
		postalCode: postal(),
		countryCode: country(),
		phoneNumber: phone(),
		...additionalData,
	};
}

function getAmazonPayCheckoutScript(country: string) {
	switch (country) {
		case 'US':
			return 'https://static-na.payments-amazon.com/checkout.js';
		case 'JP':
			return 'https://static-fe.payments-amazon.com/checkout.js';
		case 'GB':
		case 'DK':
		case 'FR':
		case 'DE':
		case 'HU':
		case 'IT':
		case 'LU':
		case 'AW':
		case 'PT':
		case 'ES':
		case 'SE':
			return 'https://static-eu.payments-amazon.com/checkout.js';
		default:
			return undefined;
	}
}

/**
 * Creates and returns a popup window centered on the screen
 * @param url URL for popup
 * @param windowName Name for popup window
 * @param win Current window object
 * @param w Width of popup
 * @param h Height of popup
 * @returns popup The created popup window object
 */
// eslint-disable-next-line max-params
function createPopupWindow(url: string | URL, windowName: string, win: Window, w: number, h: number) {
	if (win?.top !== null) {
		const y = (win.top.outerHeight / 2) + win.top.screenY - (h / 2);
		const x = (win.top.outerWidth / 2) + win.top.screenX - (w / 2);
		return win.open(url, windowName, `toolbar=no, location=no, directories=no, status=yes, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`);
	}

	return null;
}

export {amazonCustomerAddress, createPopupWindow, getAmazonPayCheckoutScript};
